import { API_URL } from "../config/Config";
import axiosInstance from "./AxiosInstance";

export default class DocumentTypesService {
	constructor() {
		this.endpoint = "/api/documents";
	}

	async downloadDocument(documentID) {
		try {
			const response = await axiosInstance.get(`${API_URL}${this.endpoint}/download/${documentID}`, {
				responseType: "blob"
			});

			// Try to get filename from content-disposition header
			const contentDisposition = response.headers["content-disposition"];
			let filename = `document-${documentID}`;

			if (contentDisposition) {
				const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
				if (filenameMatch && filenameMatch[1]) {
					filename = filenameMatch[1].replace(/['"]/g, "");
				}
			}

			// Get file extension from Content-Type header and append if needed
			const contentType = response.headers["content-type"];
			if (contentType && contentType.includes("/") && !filename.includes(".")) {
				const extension = "." + contentType.split("/")[1];
				filename += extension;
			}

			// Create a URL for the blob
			const url = window.URL.createObjectURL(new Blob([response.data]));
			const link = document.createElement("a");
			link.href = url;
			link.setAttribute("download", filename);

			// Start download
			link.click();

			// Clean up and remove the link
			window.URL.revokeObjectURL(url);
		} catch (error) {
			console.error("Error downloading document:", error);
		}
	}

	async getDocumentTypes(documentCategoryID) {
		try {
			const response = await axiosInstance.get(`${this.endpoint}/types/${documentCategoryID}`);
			return response.data;
		} catch (error) {
			console.error("Error fetching data:", error);
			return { success: false, message: "fail to proccess request" };
		}
	}
}
